// Meeting reminder types and API contracts

// API types (snake_case to match backend contract)
export interface SendReminderApiRequest {
  recipient_emails: string[];
  body_content: string;
  calendar_owner_email: string;
}

export interface SendReminderApiResponse {
  meeting_id: string;
  results: Array<{
    email: string;
    name: string;
    success: boolean;
    error: string | null;
  }>;
  total_recipients: number;
  successful_sends: number;
  failed_sends: number;
}

// Domain types (camelCase for internal use)
export interface SendMeetingReminderRequest {
  meetingId: string;
  recipientEmails: string[];
  bodyContent: string;
  calendarOwnerEmail: string;
}

export interface AttendeeReminderResult {
  email: string;
  name: string;
  success: boolean;
  error: string | null;
}

export interface SendMeetingReminderResponse {
  meetingId: string;
  results: AttendeeReminderResult[];
  totalRecipients: number;
  successfulSends: number;
  failedSends: number;
}

export interface AttendeeReminderInfo {
  lastReminderSentAt: Date | null;
  reminderCount: number;
}

// API response transformer
export const transformSendReminderResponse = (
  apiResponse: SendReminderApiResponse
): SendMeetingReminderResponse => {
  return {
    meetingId: apiResponse.meeting_id,
    results: apiResponse.results.map(result => ({
      email: result.email,
      name: result.name,
      success: result.success,
      error: result.error,
    })),
    totalRecipients: apiResponse.total_recipients,
    successfulSends: apiResponse.successful_sends,
    failedSends: apiResponse.failed_sends,
  };
};
